// extracted by mini-css-extract-plugin
export default {"card":"BurgerIngredient_card__uaGsa","ul":"BurgerIngredient_ul__80SiC","link":"BurgerIngredient_link__VkeMo"};